export default "__VITE_ASSET__B25142Sk__"